import React, { useContext } from "react";
import { StaticContentContext } from "../../Layout";
import ByIcon from "../ByIcon";
import Logo from "../Logo";
import Navigation from "../Navigation";
import "./style.scss";

function Header({content}) {
  const { staticContent } = useContext(StaticContentContext);
  const acf = content?.acf;

  if (!acf || !staticContent.header_background_image) return null;
  
  const { lightness, header_background_image } = staticContent;
  const backgroundColor = lightness ? [lightness, lightness, lightness].join(", ") : "255, 255, 255";

  return (
    <header className="Header" style={{
      backgroundImage: `url(${header_background_image})`,
      backgroundColor: `rgb(${backgroundColor})`
    }}>
      <div className="Header__excerpt">
        {acf.title_icon ? (
          <div className="Header__flex Header__margin">
            <ByIcon color={acf.title_icon_color} className="Header__icon" />
            <h1 className="Header__heading">{content?.title.rendered}</h1>
          </div>
        ) : (
          <h1 className="Header__heading Header__margin">{content?.title.rendered}</h1>
        )}
        <h2 className="Header__title">{acf.title}</h2>
        <p className="Header__description">{acf.description}</p>
      </div>
      <div className="Header__navigation">
        <Navigation />
        <div className="Header__logo">
          <Logo idPrefix="header-logo" />
        </div>
      </div>
    </header>
  );
}

export default Header;
